<template>
  <v-layout
    v-if="receipt"
    row
    align-center
    :style="myLayoutStyle"
  >
    <v-flex
      xs12
      sm10
      offset-sm1
      md10
      offset-md1
      lg10
      offset-lg1
      xl8
      offset-xl2
    >
      <v-card
        flat
        :color="theme.bg_color"
      >
        <v-card-text>
          <h2 :style="successStyle">
            {{ $t('payment_success') }}
          </h2>
          <v-divider class="mt-1 mb-1" :color="theme.orders_divider_color" />
          <v-layout
            row
            align-center
          >
            <v-flex
              xs3
              sm3
              md3
              lg2
              xl2
              :style="nameStyle"
            >{{ $t('receipt_no') }}: </v-flex>
            <v-flex
              xs9
              sm9
              md9
              lg10
              xl10
              :style="nameStyle"
            >{{ receipt.billno }}</v-flex>
          </v-layout>
          <v-layout
            row
            align-center
          >
            <v-flex
              xs3
              sm3
              md3
              lg2
              xl2
              :style="nameStyle"
            >{{ $t('table') }}: </v-flex>
            <v-flex
              xs9
              sm9
              md9
              lg10
              xl10
              :style="nameStyle"
            >{{ receipt.tablename }}</v-flex>
          </v-layout>
          <v-layout
            row
            align-center
          >
            <v-flex
              xs3
              sm3
              md3
              lg2
              xl2
              :style="nameStyle"
            >{{ $t('open_date') }}: </v-flex>
            <v-flex
              xs9
              sm9
              md9
              lg10
              xl10
              :style="nameStyle"
            >{{ receipt.open_date }}</v-flex>
          </v-layout>
          <v-divider class="mt-2 mb-2" :color="theme.orders_divider_color" />
          <div
            v-for="(o, index) in items"
            :key="index"
          >
            <bill-order :item="o" />
            <v-divider
              v-if="index === items.length - 1"
              class="mt-2 mb-1"
              :color="theme.orders_divider_color"
            />
          </div>
          <v-layout
            row
            align-center
            mb-1
          >
            <v-flex 
              xs9
              sm9
              md9
              lg10
              xl10
              class="text-xs-right"
              :style="nameStyle"
            >
              Subtotal:
            </v-flex>
            <v-flex 
              xs3
              sm3
              md3
              lg2
              xl2
              class="text-xs-right"
              :style="nameStyle"
            >
              {{ $n(parseFloat(receipt.sub_total), 'currency') }}
            </v-flex>
          </v-layout>
          <v-layout
            v-if="svc"
            row
            align-center
            mb-1
          >
            <v-flex 
              xs9
              sm9
              md9
              lg10
              xl10
              class="text-xs-right"
              :style="nameStyle"
            >
              {{ svc.name }}
            </v-flex>
            <v-flex 
              xs3
              sm3
              md3
              lg2
              xl2
              class="text-xs-right"
              :style="nameStyle"
            >
              {{ $n(parseFloat(svc.price), 'currency') }}
            </v-flex>
          </v-layout>
          <v-layout
            v-if="gst"
            row
            align-center
            mb-1
          >
            <v-flex 
              xs9
              sm9
              md9
              lg10
              xl10
              class="text-xs-right"
              :style="nameStyle"
            >
              {{ gst.name }}
            </v-flex>
            <v-flex 
              xs3
              sm3
              md3
              lg2
              xl2
              class="text-xs-right"
              :style="nameStyle"
            >
              {{ $n(parseFloat(gst.price), 'currency') }}
            </v-flex>
          </v-layout>
          <v-layout
            v-if="rounding !== 0"
            row
            align-center
            mb-1
          >
            <v-flex 
              xs9
              sm9
              md9
              lg10
              xl10
              class="text-xs-right"
              :style="nameStyle"
            >
              Rounding:
            </v-flex>
            <v-flex 
              xs3
              sm3
              md3
              lg2
              xl2
              class="text-xs-right"
              :style="nameStyle"
            >
              {{ $n(parseFloat(rounding), 'currency') }}
            </v-flex>
          </v-layout>
          <v-divider class="mt-1 mb-1" :color="theme.orders_divider_color" />
          <v-layout
            row
            align-center
            mb-1
          >
            <v-flex 
              xs9
              sm9
              md9
              lg10
              xl10
              class="text-xs-right"
            >
              <h4 :style="nameStyle">Total:</h4>
            </v-flex>
            <v-flex 
              xs3
              sm3
              md3
              lg2
              xl2
              class="text-xs-right"
            >
              <h4 :style="nameStyle">{{ $n(parseFloat(receipt.total), 'currency') }}</h4>
            </v-flex>
          </v-layout>
          <div :style="subtotalStyle">
            <v-btn
              :color="theme.btn_color_secondary"
              flat
              :disabled="disableSendEmailBtn"
              @click="sendEmail"
            >{{ $t('email_receipt') }}</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import PageTitle from '~/components/PageTitle'
import BillOrder from '~/components/BillOrder'

export default {
  name: 'receipt-view',
  metaInfo () {
    return { title: 'Receipt detail' }
  },
  components: {
    'page-title': PageTitle,
    'bill-order': BillOrder,
  },
  data: () => ({
    disableSendEmailBtn: false
  }),
  props: {
    id: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters('config', [
      'theme', 'iOS', 'inIframe'
    ]),
    ...mapGetters('receipt', [
      'receipts', 'receiptMsg'
    ]),
    myLayoutStyle () {
      return {
        marginLeft: '-8px',
        marginRight: '-8px',
        marginBottom: '-16px',
        backgroundColor: this.theme.bg_color
      }
    },
    nameStyle () {
      return {
        color: this.theme.orders_name_color
      }
    },
    subtotalStyle () {
      return {
        textAlign: 'right',
        marginTop: '20px',
        color: this.theme.color
      }
    },
    successStyle () {
      return {
        display: 'inline-block',
        lineHeight: '40px',
        color: this.theme.msg_success_color
      }
    },
    receipt () {
      return this.receipts.find(r => r.id === parseInt(this.id))
    },
    items () {
      // Orders passed from API will have items in string (Queue related API)
      if (this.receipt) {
        let items = []
        try {
          return JSON.parse(this.receipt.items)
        }
        catch (e) {
          return this.receipt.items
        }
      }
      return []
    },
    svc () {
      if (this.receipt && this.receipt.svc_total) {
        return {
          name: this.receipt.svc_name + ':' || 'SVC:',
          price: this.receipt.svc_total || 0
        }
      }
      return null
    },
    gst () {
      if (this.receipt && this.receipt.gst_total) {
        return {
          name: this.receipt.gst_name + ':' || 'GST:',
          price: this.receipt.gst_total || 0
        }
      }
      return null
    },
    rounding () {
      return -(this.receipt.rounding) || 0
    }
  },
  methods: {
    async sendEmail () {
      this.disableSendEmailBtn = true
      this.$bus.$emit('showFullLoading', true)
      await this.$store.dispatch('receipt/sendMail', this.receipt)
      this.$bus.$emit('showFullLoading', false)
      let text
      if (this.receiptMsg) {
        text = this.$t(this.receiptMsg)
        this.disableSendEmailBtn = false
      } else {
        text = this.$t('email_receipt_success_notice')
      }
      this.$store.dispatch('responseMessage', {
        type: 'error',
        text: text,
        title: this.$t('email_receipt_title'),
        modal: true
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/receipt.vue